import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

// Components imports
import NavigationBar from "../../components/common/NavigationBar";
import Pagination from "../../components/common/Pagination";
import Filter from "../../components/common/Filter";
import Button from "../../components/common/Button";

// React icons imports
import { RiArrowDownCircleLine } from "react-icons/ri";
import { RiArrowUpCircleLine } from "react-icons/ri";

// Scss imports
import css from "./AllUsers.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";

import {
  getAllUsers,
  getCertainUser,
  getCountAllUsers
} from "../../redux/actions/allUsers";

import { preparingForArchive } from "../../redux/actions/archiveActions";

interface AllUsersProps {}

const AllUsers: React.FC<AllUsersProps> = () => {
  const dispatch = useDispatch();

  let history = useHistory();

  const [query, setQuery] = useState("");

  // All page papers

  /*useEffect(() => {
    dispatch(getAllUsers(1, 10, query));
  }, []);*/

  // all users
  const allUsers = useSelector((state: any) => state.allUsers.allUsers);

  // certain user
  const certainUser = useSelector((state: any) => state.allUsers.certainUser);

  // States connected to filter
  const [filterShown, setFilterShown] = useState(false);

  // Filter state
  const [filteredActivityType, setFilteredActivityType] = useState("");
  const [filteredRoleType, setFilteredRoleType] = useState("");
  const [filteredFirstName, setFilteredFirstName] = useState("");
  const [filteredSort, setFilteredSort] = useState("");
  const [sortByDateValue, setSortByDateValue] = useState("");
  const [filteredLastName, setFilteredLastName] = useState("");
  const [filteredBusinessName, setFilteredBusinessName] = useState("");
  const [filteredPlace, setFilteredPlace] = useState("");
  const [filteredSubnumber, setFilteredSubnumber] = useState("");

  useEffect(() => {
    setFilteredSort(`&sort=${sortByDateValue}`);
  }, [sortByDateValue]);

  useEffect(() => {
    setQuery(
      filteredActivityType +
        filteredRoleType +
        filteredFirstName +
        filteredLastName +
        filteredBusinessName +
        filteredPlace +
        filteredSort
    );
  }, [
    filteredActivityType,
    filteredRoleType,
    filteredFirstName,
    filteredLastName,
    filteredBusinessName,
    filteredPlace,
    filteredSort
  ]);

  // Filter arrays
  const activeArray = [
    {
      value: "",
      name: "Изабери"
    },
    {
      value: "&active=true",
      name: "Активни корисници"
    },
    {
      value: "&active=false",
      name: "Неактивни корисници"
    }
  ];

  const roleArray = [
    {
      value: "",
      name: "Изабери"
    },
    {
      value: "&role=admin",
      name: "Админ"
    },
    {
      value: "&role=user",
      name: "Корисник"
    },
    {
      value: "&role=pending",
      name: "На чекању"
    }
  ];

  // Sort options array

  const sortByDateArray = [
    {
      value: "",
      name: "Изабери"
    },
    {
      value: "subscriptionTime",
      name: "Растући"
    },
    {
      value: "-subscriptionTime",
      name: "Опадајући"
    }
  ];

  const elementTypeRole = (element) => {
    if (element.role === "admin") {
      return "Администратор";
    } else if (element.role === "user") {
      return "Корисник";
    } else {
      return "На чекању";
    }
  };

  const elementTypeActivity = (element) => {
    if (element.active === true) {
      return "Активан";
    } else {
      return "Неактиван";
    }
  };

  // Array for generation table data
  const tableData = allUsers
    ? allUsers.map((element) => {
        const elementType = () => {
          /*if (element.paperType === "outgoing") {
        return "Долазни документ";
      } else if (element.paperType === "incoming") {
        return "Одлазни документ";
      } else {
        return "";
      }*/
        };

        return {
          firstAndLastName: element.firstName
            ? element.firstName + " " + element.lastName
            : "",
          businessName: element.businessName ? element.businessName : "",
          place: element.place ? element.place : "",
          role: element.role ? elementTypeRole(element) : "",
          active: element.active ? elementTypeActivity(element) : "",
          subscriptionTime: element.subscriptionTime
            ? element.subscriptionTime
            : "",
          _id: element._id
        };
      })
    : [];

  // all users number
  const allUsersNumber = useSelector(
    (state: any) => state.allUsers.allUsersNumber
  );

  // On change basic
  const onSelectChange = (e, setValue) => {
    setValue(e.target.value);
  };

  const [papersData, setPapersData] = useState([{}]);
  const [papers, setPapers] = useState("allUsers");
  const [pagesNumber, setPagesNumber] = useState(0);

  // Current active page
  const [activePage, setActivePage] = useState(1);

  // Page limit
  const [pageLimit, setPageLimit] = useState(10);

  const [rowsArray, setRowsArray] = useState<any>([]);

  // Fake table data
  const columns = [
    "Име и презиме",
    "Пословно име",
    "Место",
    "Улога",
    "Активност",
    "Преостало време претплате"
  ];

  const [notArchivedPapersIds, setNotArchivedPapersIds] = useState<any>([]);

  useEffect(() => {
    dispatch(getCountAllUsers(""));
    dispatch(getAllUsers(1, 10, ""));
    //dispatch(getNotArchivedPagePapers());
  }, []);

  useEffect(() => {
    if (allUsers) {
      setPapersData(
        allUsers.map((element) => {
          return {
            firstAndLastName: element.firstName ? element.firstName : "",
            businessName: element.businessName ? element.businessName : "",
            place: element.place ? element.place : "",
            role: element.role ? elementTypeRole(element) : "",
            active: element.active ? elementTypeActivity(element) : "",
            subscriptionTime: element.subscriptionTime
              ? element.subscriptionTime
              : ""
          };
        })
      );
    }
  }, [allUsers]);

  useEffect(() => {
    setPagesNumber(Math.ceil(allUsersNumber / pageLimit));
  }, [allUsersNumber]);

  useEffect(() => {
    setPagesNumber(Math.ceil(allUsersNumber / pageLimit));
  }, [allUsers]);

  useEffect(() => {
    markSelectedRow();
  }, [notArchivedPapersIds]);

  useEffect(() => {
    setRowsArray([]);
    markSelectedRow();
  }, [allUsers]);

  useEffect(() => {
    markSelectedRow();
  }, [papersData]);

  const renderTr: any = (element) => {
    const elementObject = Object.keys(element);
    return elementObject.map((el) => {
      return el !== "_id" ? <td>{`${element[el]}`}</td> : "";
    });
  };

  // Function for marking selected rows
  const markSelectedRow = () => {
    const rowsNodeList = document.querySelectorAll("tr");
    setRowsArray(Array.from(rowsNodeList));

    rowsArray.forEach((row) => {
      if (notArchivedPapersIds.includes(row.dataset.id)) {
        row.classList.add(css.markedRow);
      } else {
        row.classList.remove(css.markedRow);
      }
    });
  };

  // On row click event
  const onRowClickEvent = (el: any) => {
    const elDataSet = el.target.parentNode.getAttribute("data-id");
  };

  // Prepare for archive event
  const prepareForArchivingEvent = () => {
    dispatch(preparingForArchive(notArchivedPapersIds, history));
  };

  useEffect(() => {
    setPagesNumber(Math.ceil(allUsersNumber / pageLimit));
  }, [allUsersNumber]);

  // Filter, function for search searchDocuments
  const filterDocuments = () => {
    dispatch(getAllUsers(1, pageLimit, query));
    //setPagesNumber(Math.ceil(allUsers.length / pageLimit));
    dispatch(getCountAllUsers(query));
  };

  return (
    <div className={css.container}>
      <NavigationBar />

      <div className={css.contentContainer}>
        {/* Title part */}
        <h1>Сви корисници</h1>
        {/* Filter */}
        {allUsers && allUsers.length > 0 && (
          <div
            className={css.showFilterContainer}
            onClick={() => setFilterShown((prevState) => !prevState)}
          >
            {!filterShown && <p>Прикажи филтер</p>}
            {filterShown && <p>Сакриј филтер</p>}
            {!filterShown && <RiArrowDownCircleLine className={css.icon} />}
            {filterShown && <RiArrowUpCircleLine className={css.icon} />}
          </div>
        )}
        {filterShown && (
          <Filter
            setFilteredFirstName={setFilteredFirstName}
            setFilteredLastName={setFilteredLastName}
            setFilteredPlace={setFilteredPlace}
            setFilteredBusinessName={setFilteredBusinessName}
            onSelectActivityChange={(e) =>
              onSelectChange(e, setFilteredActivityType)
            }
            setFilteredSubnumber={setFilteredSubnumber}
            activityArray={activeArray}
            onSelectRoleChange={(e) => onSelectChange(e, setFilteredRoleType)}
            roleArray={roleArray}
            onSelectSortByDateChange={(e) => {
              onSelectChange(e, setSortByDateValue);
            }}
            sortByDateArray={sortByDateArray}
            type="allUsers"
          />
        )}
        {filterShown && (
          <div className={css.buttonWrapper}>
            <Button
              text="Претражи документа"
              onButtonClickHandler={() => filterDocuments()}
              type="filterButton"
            />
          </div>
        )}
        {allUsers && allUsers.length > 0 ? (
          <p className={css.text}>
            Кликните на корисника да погледате профил корисника
          </p>
        ) : (
          <p>Нема корисника</p>
        )}

        {/*Table */}
        {allUsers && allUsers.length > 0 && (
          <table className={`${css.table}`}>
            <thead>
              <tr>
                {columns.map(function (column) {
                  return <th>{column}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {tableData.map((element) => {
                return (
                  <tr
                    data-id={element._id}
                    onClick={(el: any) => {
                      dispatch(getCertainUser(element._id, history));
                    }}
                  >
                    {renderTr(element)}
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        {/* Pagination */}
        <Pagination
          pagesNumber={pagesNumber}
          papers={papers}
          activePage={activePage}
          setActivePage={setActivePage}
          pageLimit={pageLimit}
        />
      </div>
    </div>
  );
};

export default AllUsers;
